<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="isDisabled" [multiple]="multiple"
           [placeholder]="'hx.bank-account-select.selectBank' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.id">{{op.bank?.name}}({{op.iban}})</ng-option>
</ng-select>
